import regionL10n from './l10n/region.json';
import { getLangByHtml } from '@ncui/util-js';

type RegionL10n = { [lang: string]: { [code: string]: string } };

/**
 * 리전 코드 → 현재 언어 타이틀.
 * 1) config로 넘긴 regionNameMap(인자)에 값이 있으면 최우선 사용
 * 2) 없으면 l10n(region.json). 언어 코드는 footer 등과 동일하게
 *    getLangByHtml(@ncui/util-js)로 정규화(zh_TW/zh_CN/es_ES 등 표준 키 매칭),
 *    해당 언어/코드가 없으면 영문 → 코드 순으로 fallback.
 */
export const getRegionTitle = (
    code: string,
    nameMap?: { [code: string]: string }
): string => {
    // 1) config regionNameMap 우선
    if (nameMap?.[code]) return nameMap[code];

    // 2) 빌드 내장 l10n(region.json)
    const l10n = regionL10n as RegionL10n;
    const lang = getLangByHtml({ defaultLang: 'en' });
    const map = l10n[lang] || l10n['en'] || {};
    return map[code] || code;
};
